import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'capacidadeFormater' })
export class CapacidadeFormaterPipe implements PipeTransform {

  transform(value: any, sufix: string, casasDecimais = 2): string {
    value = value || 0;
    const numero = Number(value);
    const casasDecimaisAExibir = Number.isInteger(numero) ? 0 : casasDecimais;
    return numero.toFixed(casasDecimaisAExibir).concat(' ').concat(sufix);
  }
}
